import { useState } from 'react'
import { supabase } from './supabaseClient'

// Google OAuth is the only sign-in path. Workspace-restricted internal
// consent means only @altsportsdata.com accounts can complete the flow.
// Lands at /auth/callback on the same origin; supabase-js's
// detectSessionInUrl handles the code/fragment exchange before
// AuthCallback even mounts.

export default function MagicLinkLogin() {
  const [busy, setBusy] = useState(false)
  const [error, setError] = useState<string | null>(null)

  async function handleGoogle() {
    setError(null)
    setBusy(true)
    try {
      const { error: authError } = await supabase.auth.signInWithOAuth({
        provider: 'google',
        options: {
          redirectTo: `${window.location.origin}/auth/callback`,
        },
      })
      if (authError) {
        setError(authError.message)
        setBusy(false)
      }
      // No else — on success, browser navigates to Google so this component unmounts.
    }
    catch (err) {
      setError(`Network error: ${(err as Error).message}`)
      setBusy(false)
    }
  }

  return (
    <div className="brutalist-root">
      <div className="lg-screen">
        <div className="lg-card">
          <div className="lg-tag">[ AUTH ] ALTSPORTS_DATA</div>
          <h1 className="lg-title">Sign in</h1>
          <p className="lg-sub">
            Sign in with your @altsportsdata.com Google account.
          </p>
          <button
            type="button"
            onClick={handleGoogle}
            disabled={busy}
            className="lg-google"
          >
            <GoogleGlyph />
            <span>{busy ? 'REDIRECTING…' : 'CONTINUE WITH GOOGLE'}</span>
          </button>
          {error && (
            <p className="lg-error b-mono">⚠ {error}</p>
          )}
          <p className="lg-foot b-mono-dim">
            No account? Ask Cole to invite you. Sign-ups are invite-only.
          </p>
        </div>
      </div>
    </div>
  )
}

function GoogleGlyph() {
  // Google's official multicolor "G" glyph. Sized to 18px so it sits in
  // line with the JetBrains Mono button text.
  return (
    <svg width="18" height="18" viewBox="0 0 18 18" aria-hidden="true">
      <path fill="#4285F4" d="M17.64 9.2c0-.637-.057-1.251-.164-1.84H9v3.481h4.844a4.14 4.14 0 0 1-1.796 2.717v2.258h2.908c1.702-1.567 2.684-3.874 2.684-6.615z" />
      <path fill="#34A853" d="M9 18c2.43 0 4.467-.806 5.956-2.18l-2.908-2.259c-.806.54-1.837.86-3.048.86-2.344 0-4.328-1.584-5.036-3.711H.957v2.332A8.997 8.997 0 0 0 9 18z" />
      <path fill="#FBBC05" d="M3.964 10.71A5.41 5.41 0 0 1 3.682 9c0-.593.102-1.17.282-1.71V4.958H.957A8.996 8.996 0 0 0 0 9c0 1.452.348 2.827.957 4.042l3.007-2.332z" />
      <path fill="#EA4335" d="M9 3.58c1.321 0 2.508.454 3.44 1.345l2.582-2.58C13.463.891 11.426 0 9 0A8.997 8.997 0 0 0 .957 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" />
    </svg>
  )
}
